import { Square, Plus } from 'lucide-react';
import { Button } from '@/components/Button';
import { EmptyState } from '@/components/EmptyState';

export function BuildPlatesPage() {
  return (
    <div className="p-4">
      {/* Page header */}
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h1 className="text-lg font-semibold text-foreground">Build Plates</h1>
          <p className="text-sm text-foreground-muted">Manage your build plate inventory</p>
        </div>
        <Button size="sm" leftIcon={<Plus className="h-4 w-4" />}>
          Add Build Plate
        </Button>
      </div>

      {/* Empty state */}
      <div className="rounded border border-border bg-background-subtle p-4">
        <EmptyState
          icon={<Square className="h-10 w-10" />}
          title="No build plates yet"
          description="Track your build plates including surfaces, sizes, and compatibility."
          actionLabel="Add Build Plate"
          onAction={() => {
            // TODO: Open add build plate modal
          }}
        />
      </div>
    </div>
  );
}
